var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeactivatedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0H13L20 4V20H7L0 16V0Z",
  fill: "#E0A3A3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0001 10.7072L13.1465 13.8536L13.8536 13.1465L10.7072 10.0001L13.8536 6.85364L13.1465 6.14653L10.0001 9.29295L6.85359 6.14648L6.14648 6.85359L9.29295 10.0001L6.14648 13.1465L6.85359 13.8536L10.0001 10.7072Z",
  fill: "#861313"
})));
export { SvgDeactivatedIcon as ReactComponent };
export default __webpack_public_path__ + "assets/0fee25e2.svg";